import type { NotificationBarCallbackReason } from '../schema/NotificationInterfaces';

let notificationBarCallback: (reason: NotificationBarCallbackReason) => void;

/**
 * gets the notification bar callback function
 * @return callback function
 */
export function getNotificationBarCallback(): (reason: NotificationBarCallbackReason) => void {
    return notificationBarCallback;
}

/**
 * sets the notification bar callback function
 * @param callback function for the given notification
 */
export function setNotificationBarCallback(
    callback: (reason: NotificationBarCallbackReason) => void
) {
    if (notificationBarCallback) {
        throw new Error('Cannot over write an existing notification callback.');
    }

    notificationBarCallback = callback;
}

/**
 * remove the notification bar callback function
 */
export function removeNotificationBarCallback() {
    notificationBarCallback = null;
}
